import './styles/global';
import React from 'react';
import ReactDOM from 'react-dom';
import { Root } from './root.component';
import { initGA } from './utils/google';
import pkg from '../package.json';

console.log(`${pkg.name} v${pkg.version}`);
initGA();

ReactDOM.render(<Root />, document.getElementById('root'));
